import { render, staticRenderFns } from "./ShipmentsExport.vue?vue&type=template&id=4ae8617c&scoped=true"
import script from "./ShipmentsExport.vue?vue&type=script&lang=js"
export * from "./ShipmentsExport.vue?vue&type=script&lang=js"
import style0 from "./ShipmentsExport.vue?vue&type=style&index=0&id=4ae8617c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae8617c",
  null
  
)

export default component.exports